import config from "../config";
import Axios from 'axios';
export default {
    actions: {
        async fetchCities({commit, state}) {
            const resp = await Axios.get('/api/cities', config());
            commit('setCities', resp.data);
            return true;
        },
    },
    mutations: {
        setCities(state, cities){
            state.cities = cities.data;
            state.cityName = cities.meta.current;
            state.point.lat = cities.meta.lat;
            state.point.lon = cities.meta.lon;
        }
    },
    state: {
        cities: {},
        cityName: null,
        point: {
            lat: null,
            lon: null
        }
    },
    getters: {
        cities(state){
            return state.cities;
        },
        currentCityPoint(state) {
            return state.point;
        },
        cityName(state) {
            return state.cityName;
        }
    },
}